import { type ReactNode, createContext, useContext, useEffect } from 'react';

export interface Chrome {
  /** header crumb section ("Projects", "Work"…) */
  section: string;
  /** header current item (project name + status badge, or page name) */
  current?: ReactNode;
  /** contextual secondary sidebar content */
  secondary?: ReactNode;
  /** mobile drawer title of the secondary sidebar */
  secondaryTitle?: string;
  /** right rail (≥1440px) */
  rail?: ReactNode;
  /** header Share / Views buttons (project pages) */
  projectActions?: ReactNode;
  /** page supports full-screen focus mode (project views) */
  focusable?: boolean;
  /** hide the FAB (e.g. Inbox) */
  hideFab?: boolean;
}

export interface NewMissionDefaults {
  projectId?: string;
  statusId?: string;
  dueAt?: string | null;
}

export interface ShellApi {
  /** current workspace (header switcher) */
  workspaceId: string;
  setChrome(c: Chrome): void;
  openNewMission(d?: NewMissionDefaults): void;
  openMission(id: string): void;
  openNotifications(): void;
  openPrefs(): void;
  focus: boolean;
  setFocus(on: boolean): void;
  openDrawer(which: 'p' | 's'): void;
  closeDrawers(): void;
}

export const ShellCtx = createContext<ShellApi | null>(null);

export function useShell(): ShellApi {
  const c = useContext(ShellCtx);
  if (!c) throw new Error('useShell() must be used inside <AppShell>');
  return c;
}

/** Pages declare their header crumb, secondary sidebar and rail. Re-applies when deps change. */
export function useChrome(chrome: Chrome, deps: unknown[]): void {
  const shell = useShell();
  useEffect(() => {
    shell.setChrome(chrome);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
